import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Clock, ChevronRight } from 'lucide-react';
import { PollStatusBadge } from './PollStatusBadge';

interface PollCardProps {
  pollId: string;
  title: string;
  status: string;
  responseCount?: number;
  closesAt: string | null;
  createdAt: string;
}

export function PollCard({
  pollId,
  title,
  status,
  responseCount,
  closesAt,
  createdAt,
}: PollCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="group cursor-pointer hover:border-primary/30 hover:shadow-sm transition-all"
      onClick={() => navigate(`/a/arche_polls/${pollId}`)}
    >
      <CardContent className="flex items-center gap-4 py-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2.5 mb-1.5">
            <h3 className="font-medium truncate">{title}</h3>
            <PollStatusBadge status={status} />
          </div>
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            {responseCount !== undefined && (
              <span className="flex items-center gap-1">
                <Users className="h-3 w-3" />
                {responseCount} {responseCount === 1 ? 'response' : 'responses'}
              </span>
            )}
            <span>Created {new Date(createdAt).toLocaleDateString()}</span>
            {closesAt && (
              <span className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {new Date(closesAt) > new Date() ? 'Closes' : 'Closed'}{' '}
                {new Date(closesAt).toLocaleDateString()}
              </span>
            )}
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-muted-foreground/50 group-hover:text-muted-foreground transition-colors shrink-0" />
      </CardContent>
    </Card>
  );
}
